<template src="../templates/bookingsRowComponent.html"></template>

<script>
    import DynamicBookingDetail from "./DynamicBookingDetail";
    import InterpreterDetailsComponent from "./InterpreterDetailsComponent";
    import {EventBus} from '../event-bus.js';
    import GetFileModel from "../models/GetFileModel";
    import pdf from 'vue-pdf'

    export default {
        name: "BookingsRow",
        components: {DynamicBookingDetail, InterpreterDetailsComponent, pdf},
        data() {
            return {
              GetFileModel: new GetFileModel(),
                showDetails: false,
                expandButtonClass: "el-table__expand-icon",
                interpreterDialogVisible: false,
                cancelDialogVisible: false,
                cancellationRequired: "",
                modalShow: false,
                showDetailsOnHover: false,
                isInEditMode: false,
                saveChanges: false,
	            cancellationReasonExplained: "",
              imageUrl:'',
              filename: null,
              dialogFormVisible: false,
              imgLoading: true,
              imgNoError: true,
              imgExt: 'pdf',
	            requestChangeWarning: "Please note only <strong>Booking Time</strong> and <strong>CALD Details</strong> can be requested for change, for other changes please contact All Graduates at " +
					"<a href='mailto:bookingteam@allgraduates.com.au' target='_top' class='ag-link-default pl-1'>bookingteam@allgraduates.com.au</a>"
            }
        },
        props: {
            bookingModel: {
                type: Object
            },
            tickAll: {
                type: Boolean
            }
        },
        watch: {
	        'bookingModel.selected': function (newVal, oldVal) {
                if (this.bookingModel != null) {
                    // this.bookingModel.location = newVal;
                    console.log('Prop changed: ', newVal, ' | was: ', oldVal);
					EventBus.$emit('jobRowSelected', newVal)
                }
            }
        },
		created() {
			// This is important to make sure DOM is aware that the checkbox model's status is false. With 0 value, we need to double click!
			if (this.bookingModel.selected == 0) this.bookingModel.selected = false;
		},
        methods: {
              showJobsSlip(val){
                this.filename = val;
                this.imgExt = val.split('.')[1];
                let url =  this.$localApiURL + this.GetFileModel.getRoute('getJobSlip') + '/'+this.filename+'?token=' + localStorage.getItem("jwt");
                this.dialogFormVisible = true;
                fetch(url)
                  .then(response => {
                    response.blob();
                    console.log('image response', response);
                    if(response.status >= 200 && response.status < 300){
                      // this.imgLoading = false;
                    }else{
                      this.imgNoError = false;
                    }
                    this.imgLoading = false;
                  })
                  .then(imageBlob => {
                      const imageObjectURL = URL.createObjectURL(imageBlob);
                      console.log(imageObjectURL);
                  });
                this.imageUrl = url;

              },
            showHideDetails() {
                this.showDetails = !this.showDetails;
                this.showDetailsOnHover = false;
                this.expandButtonClass = this.showDetails ? "el-table__expand-icon el-table__expand-icon--expanded" : "el-table__expand-icon";
                this.requestChanges();
            },
            requestChanges() {
                this.isInEditMode = false;
                this.saveChanges = true;
            },
            setEditMode(){

            	if ( this.isInEditMode === false ) {
		            this.isInEditMode = true;
		            this.saveChanges = false;
				}
				else {
		            this.isInEditMode = false;
				}

            	if (this.isInEditMode === true) {
		            this.$alert(this.requestChangeWarning, 'Warning', {
			            type: 'warning',
			            dangerouslyUseHTMLString: true,
			            confirmButtonText: 'OK',
			            center: true
		            });
				}
            },
            showDetailsOnHoverTrigger() {
                if (!this.showDetails) this.showDetailsOnHover = true;
            },
            processActivityStatusRules(job) {

                let currentDate = new Date();
                let strDateStart = job.service_date_safari + ' ' + job.start_safari;
                let strDateEnd = job.service_date_safari + ' ' + job.end_safari;

                let dateTimeStart = (Date.parse(strDateStart) / 1000).toFixed();
                let dateTimeEnd = (Date.parse(strDateEnd) / 1000).toFixed();

                const dateObjN = new Date();
                let dateNow = (dateObjN / 1000).toFixed();

                const dateObjP = new Date(strDateStart);
                const minus30FromServiceStartTime = dateObjP.setMinutes(dateObjP.getMinutes() - 30);
                const minus30Date = new Date(minus30FromServiceStartTime);

                let calculateMinusDateTime = (minus30Date / 1000).toFixed();

                if (job.is_clocked_off === "1") {
                    job.activityStatus = "circleGreenOk clockOff"; // clock off
                }
                else if (job.service_date < currentDate) {
                    job.activityStatus = "circleRed"; // old service date.
                }
                else if (job.is_clocked_on === "0") {
                    /** Condition 1: Job start not in the future or Job end is not in the past **/
                    if (dateNow > dateTimeStart && dateNow < dateTimeEnd) {
                        /** Job is within Start and End Time **/
                        // console.log('Job is within Start and End Time');
                        job.activityStatus = "circleRed";
                    }
                    else if (dateNow <= dateTimeStart && calculateMinusDateTime <= dateNow) {
                        /** Job is within 30 minutes of start **/
                        // console.log('Job is within 30 minutes of start');
                        job.activityStatus = "within30Minutes";
                    }
                    else {
                        /** Job is not within Start and End Time **/
                        // console.log('Job is not within Start and End Time');
                        job.activityStatus = "notWithinTimeRange";
                    }

                    if (job.is_late_sms_sent === "1") {
                        job.activityStatus = "circleOrange"; // late sms
                    }
                    else if (job.is_not_started === "1" || job.is_late_clocked_on === "1") {
                        job.activityStatus = "circleAmber"; // not started or late clock on
                    }
                } else {
                    job.activityStatus = "circleGreen"; // clocked on
                }
            },
            showCancelDialog() {
                this.cancelDialogVisible = true;
            },
            cancelJob() {
                this.cancelDialogVisible = false;
                let url = this.$localApiURL + "job/" + this.bookingModel.id;
                let localThis = this;
                this.$http.post(url, {
                    cancellationReason: this.cancellationReasonExplained,
                    token: localStorage.getItem("jwt")
                }).then(function (response) {
                    if (response.data != null && response.data.error === false) {
	                    localThis.$emit("cancelJobSucceed");
	                    alert("Successfully Cancelled");
                    } else {
                        alert(response.data.message);
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            hideBookingDetails() {
                this.showHideDetails();
            }
        },
        mounted() {
            let self = this;
            EventBus.$on('activity-bus-message', (category, data) => {
                if (self.bookingModel !== null && data != null && data.job_id != null && data.job_id.toString() === self.bookingModel.ref_num) {

                    self.bookingModel.early_clock_off = data.early_clock_off.toString();
                    self.bookingModel.is_clocked_off = data.is_clocked_off.toString();
                    self.bookingModel.is_late_sms_sent = data.is_late_sms_sent.toString();
                    self.bookingModel.is_not_started = data.is_not_started.toString();
                    self.bookingModel.is_late_clocked_on = data.is_late_clocked_on.toString();
                    self.bookingModel.is_clocked_on = data.is_clocked_on.toString();
                    self.processActivityStatusRules(self.bookingModel);
                }
            });


        }
    }
</script>

<style scoped>
	.cancelDialogManipulation >>> .el-dialog__body {
		padding: 10px 25px 0 25px !important;
	}
</style>



// WEBPACK FOOTER //
// src/components/BookingsRowComponent.vue